// Libraries
var React = require('react');

class HashChange extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		
		if (typeof window === "undefined") return;

		window.addEventListener("load", (event) => {

			if (window.location.hash) {

				this.triggerAccordionOpenCheck(window.location.hash);

				const targetElement = document.querySelector(window.location.hash);

				if (targetElement) {
					
					setTimeout(() => {
            
						this.goToElement(targetElement);
			
					}, 1000);
				
				}

			}

			const links = document.querySelectorAll('a[href^="#"]');

			if (!links.length) return;

			links.forEach(link => {
				
				link.addEventListener('click', (e) => {

					this.handleLinkClick(e);
					e.preventDefault();

				});

			});

		});

	}

	handleLinkClick(e) {

		const href = e.target.getAttribute('href');
		const targetElement = document.querySelector(href);

		if (!targetElement) return;

		this.triggerAccordionOpenCheck(href);

		this.goToElement(targetElement, href);

	}

	goToElement(targetElement, href) {

		const subNav = document.querySelector('.SubNavigation');
		const searchBarDesktop = document.querySelector('.SearchBarDesktop');

		if (!subNav || !searchBarDesktop || !targetElement) return;

		let offset = this.isMobile() ? subNav.offsetHeight : searchBarDesktop.offsetHeight;
		if (targetElement.getBoundingClientRect().top > 0) { offset = 0; }

		let position = (targetElement.getBoundingClientRect().top + window.pageYOffset) - offset;

		window.scroll({ top: position, left: 0, behavior: 'auto' });
		if (href) { window.history.replaceState(undefined, undefined, href); }

	}

	isMobile() {

		return matchMedia('(max-width: 999px)').matches; 

	}

	triggerAccordionOpenCheck(id) {

		const accordionEvent = new CustomEvent('openImageCopyAccordion', { detail: { id: id }});
		document.dispatchEvent(accordionEvent);

	}

	render() {
		return ''
	}
}

module.exports = HashChange;



// WEBPACK FOOTER //
// ./src/components/HashChange/HashChangeModule.js